import { render, staticRenderFns } from "./jikao.vue?vue&type=template&id=1b54640d&scoped=true"
import script from "./jikao.vue?vue&type=script&lang=js"
export * from "./jikao.vue?vue&type=script&lang=js"
import style0 from "./jikao.vue?vue&type=style&index=0&id=1b54640d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b54640d",
  null
  
)

export default component.exports